export const CAMPAIGNS_PATH = '/campaigns' as const;

export const USER_COMPETITIONS_PATH = '/user/competitions' as const;

export const UTM_CAMPAIGN_QUERY = 'utm_campaign' as const;

export const UTM_SOURCE_QUERY = 'utm_source' as const;

export const REFERRAL_CODE_QUERY = 'ref-code' as const;

export const CAMPAIGN_SECTION_QUERY = 'section' as const;

export const FEATURED_CAMPAIGN_SLUG = process.env.NEXT_PUBLIC_FEATURED_CAMPAIGN_SLUG?.trim() ?? '';

export function getCampaignDetailPath(slug: string): string {
  const params = new URLSearchParams();
  params.set(UTM_CAMPAIGN_QUERY, slug);
  return `${CAMPAIGNS_PATH}?${params.toString()}`;
}

export function resolveCampaignSlugFromQuery(
  query?: Record<string, string | string[] | undefined>
): string | undefined {
  const fromQuery = query?.[UTM_CAMPAIGN_QUERY];
  if (typeof fromQuery === 'string' && fromQuery.trim()) {
    return decodeURIComponent(fromQuery.trim());
  }

  if (typeof window !== 'undefined') {
    const fromSearch = new URLSearchParams(window.location.search).get(UTM_CAMPAIGN_QUERY);
    if (fromSearch?.trim()) {
      return decodeURIComponent(fromSearch.trim());
    }
  }

  return undefined;
}

export function isCampaignPath(pathname: string): boolean {
  return pathname === CAMPAIGNS_PATH || pathname.startsWith(`${CAMPAIGNS_PATH}/`);
}

export function isUserCompetitionsPath(pathname: string): boolean {
  return pathname === USER_COMPETITIONS_PATH;
}
